define('Components/PageHeaderWidget/js/PageHeaderWidget',['hooks',
        'Components/PageHeaderWidget/js/views/PageHeaderWidgetInstanceView',
        'Components/PageHeaderWidget/js/views/EngagementsHeaderWidgetInstanceView',
        'Components/PageHeaderWidget/js/views/RecrutementHeaderWidgetInstanceView',
        'Components/PageHeaderWidget/js/models/PageHeaderWidgetInstanceModel',
        'Components/PageHeaderWidget/js/models/PageHeaderV2Model',
        'Components/PageHeaderWidget/js/views/PageHeaderV2View',
        'Components/PageHeaderWidget/js/models/PageHeaderV3Model',
        'Components/PageHeaderWidget/js/views/PageHeaderV3View',
        'Components/PageHeaderWidget/js/views/PageHeaderAcquisitionView',
        'Components/PageHeaderWidget/js/models/PageHeaderAcquisitionModel'
    ],
    function (hooks,
              PageHeaderWidgetInstanceView,
              EngagementsHeaderWidgetInstanceView,
              RecrutementHeaderWidgetInstanceView,
              PageHeaderWidgetInstanceModel,
              PageHeaderV2Model,
              PageHeaderV2View,
              PageHeaderV3Model,
              PageHeaderV3View,
              PageHeaderAcquisitionView,
              PageHeaderAcquisitionModel) {

        return function () {
            hooks.registerWidgetInstance('PageHeaderWidget',
                {
                    'home': PageHeaderWidgetInstanceView,
                    'home-v2': PageHeaderV2View,
                    'home-v3': PageHeaderV3View,
                    'engagements': EngagementsHeaderWidgetInstanceView,
                    'recrutement': RecrutementHeaderWidgetInstanceView,
                    'acquisition': PageHeaderAcquisitionView,
                }, {
                    'home': PageHeaderWidgetInstanceModel,
                    'home-v2': PageHeaderV2Model,
                    'home-v3': PageHeaderV3Model,
                    'engagements': PageHeaderWidgetInstanceModel,
                    'recrutement': PageHeaderWidgetInstanceModel,
                    'acquisition': PageHeaderAcquisitionModel,
                });
        }

    });
